module.exports = __webpack_public_path__ + "img/prize-04.3b13ec6b.png";